<template>
  <div>
    <user-menu />
    <div class="wrapper">
      <EnterpriseAdminSidebarMenu 
        readOnly=""
      />
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div class="modal-custom" v-show="showOverlay">
            <div class="loader-img-center">
              <i class="fa fa-spinner fa-spin"></i> Please wait...
            </div>
          </div>
          <div class="">
            <i class="fa fa-chevron-left modal-goback" @click="goToLocationWindow()"></i>
            <h3 class="d-inline heading">Usage Report</h3>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>

        <div style="clear: both;"></div>
        <div class="rep_audit_bg">
          <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
          <div v-if="loading == false">
          <div class="row">
            <div class="col-12" style="margin-bottom: 10px;">
              <h3 class="col-12 col-xl-9 float-left p-0 rep_heading">Usage Report</h3>
              <div class="col-12 col-xl-3  " style="float: right; text-align: right; margin-top: 0px; padding-right: 0 !important;">

                <div v-if="results.length > 0" class=""  style="margin-top: 2px;float: right;margin-left: 15px;" @click="shareButtonModal()"><img class="" src="@/assets/Send_Report_Button.svg" alt="MentorMentee" width="24px" style="cursor: pointer;" /></div>

                <div v-if="results.length > 0" style="margin-left: 15px; margin-top: 3px; float: right; margin-right: 0px; margin-top: 2px;" @click="exportCSVAction()"><img v-if="results.length > 0"  class="" src="@/assets/Download_Report.svg" alt="MentorMentee" width="24px" style="cursor: pointer;" /></div>

              </div>
              <div style="clear: both;"></div>



            </div>
          </div>
          
          <div class="row report_heading">
            <div class="field_1">No</div>
            <div class="field_2">Location Name</div>
            <div class="field_3">Number of Managers</div>
            <div class="field_4">Number of Mentors</div>
            <div class="field_5">Number of Mentees</div>
            <div class="field_6">Reps to Review</div>
            <div class="field_7">Reps Recorded</div>
            <div class="field_8">Competencies Earned</div>
            <div class="field_9">Inactive Mentees</div>
            <div class="col-12">
                <div class="custom_heading_hr"></div>
            </div>
          </div>

          <div class="row report_view" v-for="(result,rindex) in results" :key="rindex">
            <div class="field_1">{{ parseInt(rindex + 1) }}</div>
            <div class="field_2">{{ result.accountName }}</div>
            <div class="field_3 text-align-center">{{ result.managerCount }}</div>
            <div class="field_4 text-align-center">{{ result.mentorCount }}</div>
            <div class="field_5 text-align-center">{{ result.menteeCount }}</div>
            <div class="field_6 text-align-center">{{ result.repsReviewCount }}</div>
            <div class="field_7 text-align-center">{{ result.repsAddedCount }}</div>
            <div class="field_8 text-align-center">{{ result.competencyEarnedCount }}</div>
            <div class="field_9 text-align-center">{{ result.inactivementeeCount }}</div>
            <div class="col-12">
                <div class="custom_hr"></div>
            </div>
          </div>

          <div class="row report_heading" >
            <div class="field_1">&nbsp;</div>
            <div class="field_2">Total</div>
            <div class="field_3 text-align-center">{{ totalManagerCount }}</div>
            <div class="field_4 text-align-center">{{ totalMentorCount }}</div>
            <div class="field_5 text-align-center">{{ totalMenteeCount }}</div>
            <div class="field_6 text-align-center">{{ totalRepsReviewCount }}</div>
            <div class="field_7 text-align-center">{{ totalRepsAddedCount }}</div>
            <div class="field_8 text-align-center">{{ totalCompetencyEarnedCount }}</div>
            <div class="field_9 text-align-center">{{ totalInactiveMenteeCount }}</div>
          </div>
          </div>

        </div>

        </div>


      </div>
    </div>


    <ShareReportModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Share Report</h3></div>
      <div slot="body">
        <div v-if="showShareSuccess == true" class="col-12 override-padding" style="color: #68C47E; text-align: center; margin-bottom: 15px;">
          <b>Report shared successfully!</b>
        </div>
        <div class="col-12 override-padding">
          <input v-model="share_email"
                name="share_email"
                placeholder="Enter Email..."
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required|email'"
                data-vv-as="Email address"
                maxlength="255" />
         <div v-show="verrors.has('share_email')" class="validate-warning-msg">{{ verrors.first('share_email') }}</div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>


        <div v-if="showWait == false" class="col-12 override-padding text-align-right">
          <button
              v-on:click="shareButtonSubmit()"
              class="btn btn-dard-grey col-lg-3"
              style="line-height: 30px; border-radius: 10px;"
              ><b>{{ submit_text }}</b></button>
        </div>
        <div v-if="showWait == true" class="col-12 override-padding text-align-right">
          <button
              
              class="btn btn-dard-grey col-lg-3"
              style="line-height: 30px; border-radius: 10px;"
              ><b>Please wait...</b></button>
        </div>

      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </ShareReportModal>


      <BatchModal :isModalVisible="isExportModalVisible" @close="isExportModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading"></div>
        <div slot="body">
          <div class="">
            <div class="export-details">
              Exported: {{ rowsExportedCSV }} of {{ rowsCSV}}
            </div>
            <div class="percentage-text">
              {{ percentage }}
            </div>
            <div class="batch-box">
              <div class="batch-loading" id="batch-loading" >
                &nbsp;
              </div>
            </div>
            <div class="download-link" @click="downloadFunc()" v-if="percentage == '100%'">
              Download CSV File
            </div>
          </div>
        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </BatchModal>


  </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import ShareReportModal from '../enterpriseadmin/share_email_report_modal.vue';
import VeeValidate from 'vee-validate';
import BatchModal from '../admin/reports/report_loading_modal.vue';
import router from '../../router/index.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    data() {
        return {
            loading: false,
            showOverlay: false,
            results: [],
            totalManagerCount: 0,
            totalMentorCount: 0,
            totalMenteeCount: 0,
            totalRepsReviewCount: 0,
            totalRepsAddedCount: 0,
            totalCompetencyEarnedCount: 0,
            totalInactiveMenteeCount: 0,
            apiUrl: '',
            isModalVisible: false,
            submit_text: 'Submit',
            share_email: '',
            showOverlay: false,
            showWait: false,
            showShareSuccess: false,
            isExportModalVisible: false,
            percentage: '0%',
            fileName: '',
            totalCSVPages: 0,
            perCSVPage: 500,
            rowsCSV: 0,
            rowsExportedCSV: 0,
            currentCSVPage: 1,
        }
    },
    components: {
        UserMenu,
        EnterpriseAdminSidebarMenu,
        ShareReportModal,
        BatchModal,
    },
    methods: {
        goToLocationWindow() {
          router.push('/enterprise-admin-dashboard');
        },
        shareButtonSubmit: function() {
          this.$validator.validateAll().then((result) => {
            if ((this.verrors.items.length === 0)) {
              this.submit_text = 'Please wait...';
              this.showWait = true;
              this.currentCSVPage = 1;
              this.rowsCSV = 0;
              this.rowsExportedCSV = 0;
              this.totalCSVPages = 0;
              this.percentage = 0;
              this.fileName = '';
              this.showWait = true;

              axios('/enterprise-admin/share-usage-report',              
              {
                  method: 'POST',
                  data: {            
                    email: this.share_email,
                  },
                })

              .then((resp) => {
                this.share_email = '';
                this.submit_text = 'Submit';
                this.share_button_disable = true;
                this.showWait = false;
                this.showShareSuccess = true;
                setTimeout(() => {
                    this.showShareSuccess = false;
                }, 5000)

               })
              .catch(error => {

              });
            }
          });
        },

        shareButtonModal() {
          this.isModalVisible = true;
        },

        downloadFunc: function() {
          var url = this.apiUrl + '/custom/csv-view/' + this.fileName + '/Usage';
          window.location.href = url;
          this.isExportModalVisible = false;
          return false;
        },
        exportCSVAction: function() {
          this.isExportModalVisible = false;
          this.currentCSVPage = 1;
          this.rowsCSV = 0;
          this.rowsExportedCSV = 0;
          this.totalCSVPages = 0;
          this.percentage = 0;
          this.fileName = '';
          this.fetchUsageListCSV();
        },
        fetchUsageListCSV: function() {

          axios.get('/enterprise-admin/usage-report-csv', {
          })
          .then(response =>  {

              this.isExportModalVisible = true;
              this.currentCSVPage = response.data.page;
              this.rowsCSV = response.data.total_rows;
              this.rowsExportedCSV = response.data.total_rows_exported;
              this.totalCSVPages = response.data.total_pages;
              this.percentage = response.data.percentage;
              this.fileName = response.data.file_name;
              document.getElementById("batch-loading").style.width = this.percentage;
              if(this.currentCSVPage <= this.totalCSVPages) {
                this.fetchUsageListCSV();
              }

          })
          .catch(function(error) {
            console.log(error);
          });
        },



        fetchIUsersListitems() {
          this.loading = true;
          axios.get('/enterprise-admin/account_usage_report')
          .then(response =>  {
              this.loading = false;
              this.results = response.data.data;
              this.totalManagerCount = response.data.totalManagerCount;
              this.totalMentorCount = response.data.totalMentorCount;
              this.totalMenteeCount = response.data.totalMenteeCount;
              this.totalRepsReviewCount = response.data.totalRepsReviewCount;
              this.totalRepsAddedCount = response.data.totalRepsAddedCount;
              this.totalCompetencyEarnedCount = response.data.totalCompetencyEarnedCount;
              this.totalInactiveMenteeCount = response.data.totalInactiveMenteeCount;
          })
          .catch(function(error) {
              console.log(error);
          });
        },
    },
    created() {
      this.apiUrl = process.env.API_ENDPOINT;
      this.fetchIUsersListitems();
    }
}
</script>
<style scoped>
.modal-goback { font-size: 22px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-header .sub-heading h3 {
  color: #002F42;
  font-size: 15px;
  font-weight: 900;
}
.rep_audit_bg {
    background-color: #FFF;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 10px;
}
.rep_heading {    
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 10px;
}
.report_heading {   
    font-size: 14px; 
    padding-top: 8px;
    padding-bottom: 8px;
    font-weight: bold;
}
.custom_heading_hr, .custom_hr {
  width: 100%;
  margin: 5px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.custom_heading_hr {
    border-bottom: 3px solid #A3A3A3;
}
.field_1 {
  width: 5%;
  padding-left: 15px;
}
.field_3, .field_4, .field_5, .field_6, .field_7, .field_8, .field_9 {
  width: 11%;
}
.field_9 {
  padding-right: 15px;
}
.field_2 {
  width: 18%;
}
.circle {
  background-color: #2EACEE;  
  border-radius: 50%;
  height: 36px;
  width: 36px;
  text-align: center;
}
.circle i {
  color: #FFF;  
  font-size: 24px;
  text-align: center;
  padding-top: 5px;
  padding-right: 2px;
}
.print-section {
    font-family: "proxima-nova",sans-serif;
    color: #002F42;
}
</style>




// WEBPACK FOOTER //
// src/components/enterpriseadmin/usage_report.vue